import * as types from 'store/actions/types';
import produce from 'immer';

export const INITIAL_STATE = {
	loading: true,
	error: false,
	data: []
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ****************** CLEAR DATA ******************
			case types.CLEAR_STATE:
				return { ...INITIAL_STATE };

			// *************** FETCH ALL CATEGORIES ***************
			case types.FETCH_ALL_CATEGORIES_LOADING:
				draft.loading = true;
				draft.error = false;
				return;

			case types.FETCH_ALL_CATEGORIES_SUCCESS:
				draft.loading = false;
				draft.data = action.payload.data;
				return;

			case types.FETCH_ALL_CATEGORIES_ERROR:
				draft.error = action.payload;
				return;

			default:
				return state;
		}
	});
